import * as React from "react";
import { SVGProps } from "react";

const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" {...props}>
    <defs>
      <style>{".a5128287-1b2f-4aa7-bf83-e3d0a2d719c7{fill:#18a0b1}"}</style>
    </defs>
    <g id="aa8d72f3-e91d-4668-864f-f6ccd32ab5ee" data-name="Calque 2">
      <g id="f48437ee-df2e-4d1f-8155-a51b945f34ec" data-name="Line">
        <g id="fb56a67f-1a1b-4fcb-afaf-5bdfb7c20b92" data-name="icon">
          <circle
            cx={26.5}
            cy={2.5}
            r={2.5}
            className="a5128287-1b2f-4aa7-bf83-e3d0a2d719c7"
          />
          <path
            d="M7.28 18.79A8.37 8.37 0 0 1 18.74 7.33l2-2-.1-.08A11.14 11.14 0 0 0 5.28 20.79Zm14.44-8.47a8.37 8.37 0 0 1-11.46 11.46l-2 2A11.13 11.13 0 0 0 23.72 8.32Z"
            className="a5128287-1b2f-4aa7-bf83-e3d0a2d719c7"
          />
          <circle
            cx={2.5}
            cy={26.5}
            r={2.5}
            className="a5128287-1b2f-4aa7-bf83-e3d0a2d719c7"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Icon;
